// src/constants/tagTypes.js
export const TAG_TYPES = {
  PET: 'Pet',
  ACCESS_TOKEN: 'AccessToken',
  CLAIMS: 'Claims',
  VETS: 'Vets',
  SAVED_UPLOADED_DOCUMENTS: 'SavedUploadedDocuments',
  SAVED_CLAIM: 'SavedClaim'
};
